// --------------------------------------------------------------
// Created On: 2021-05-14
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import styles from "./NavbarAssetLink.module.scss";

// A single clickable link on a navbar that corresponds to an asset.
export default function NavbarAssetLink(props: Props): Component {
  const { assetId } = useParams<Params>();

  return (
    <li
      className={`${styles.item} mx-3 ${
        props.targetPage.replace("*", assetId || "0") === props.currentPage ? styles.active : ""
      }`}
    >
      <Link className={styles.link} to={props.targetPage.replace("*", assetId || "0")}>
        <span>{props.name}</span>
      </Link>
    </li>
  );
}

interface Props {
  name: string;
  targetPage: string;
  currentPage: string;
}

type Params = {
  assetId: string;
};
